import "./PreviewFrame.css";

export default function PreviewFrame(props) {
  return (
    <div className="preview-frame col">
      <span className="preview-frame-label t-eyebrow t-dimmer">
        As the participant sees it
      </span>
      <div className="preview-frame-stage" aria-hidden="true" inert="">
        {props.children}
      </div>
    </div>
  );
}
